'use client'

import * as React from 'react'
import {
  LuCircleHelp,
  LuClipboardList,
  LuMailQuestion,
  LuShieldCheck,
} from 'react-icons/lu'

import Image from 'next/image'
import Link from 'next/link'

import { atmLogo } from '@ui/assets'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@ui/components/shadcn/ui'
import { marketingUrl } from '@ui/lib/urls'

export const NavLogo = () => {
  const { isMobile } = useSidebar()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-video size-16 items-center justify-center rounded-lg group-data-[state=collapsed]:size-8">
                <Image src={atmLogo} alt="ATM.com" />
              </div>
              <LuCircleHelp className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            align="start"
            side={isMobile ? 'bottom' : 'right'}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-muted-foreground text-xs">
              Need Help?
            </DropdownMenuLabel>
            <DropdownMenuItem asChild className="gap-2 p-2">
              <a href={marketingUrl('/#faq')} target="_blank">
                <div className="flex size-6 items-center justify-center rounded-sm border">
                  <LuClipboardList />
                </div>
                FAQs
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem asChild className="gap-2 p-2">
              <Link href="/support" target="_blank">
                <div className="flex size-6 items-center justify-center rounded-sm border">
                  <LuMailQuestion />
                </div>
                Contact Support
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild className="gap-2 p-2">
              <a href={marketingUrl('/terms-of-service')} target="_blank">
                <div className="flex size-6 items-center justify-center rounded-sm border">
                  <LuShieldCheck />
                </div>
                Terms of Service
              </a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
